import ServiceOnline from '../../pages/mine/ServiceOnline.vue'
import ServicePage from '../../pages/mine/ServicePage.vue'

// service 页面路由：统一公开路径及路由名称，组件和 meta 保持不变。
const routes = [
  { path: '/support/online', name: 'support-online', component: ServiceOnline, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/support/page', name: 'support-page', component: ServicePage, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
]

export default routes
